<template>
  <div class="container container_com-fundo card-dados card-dados_imovel">
    <h2 class="titulo titulo_grande u-margem-inferior-media">
      Dados do imóvel
    </h2>

    <div class="linha-de-dados">
      <span class="item-de-dado item-de-dado_largo">
        <strong>Construtora:</strong>
        <span>{{ construtora.Nome }}</span>
      </span>
    </div>
    <div class="linha-de-dados">
      <span class="item-de-dado">
        <strong>CNPJ:</strong>
        <span>{{ construtora.Cnpj }}</span>
      </span>
      <span class="item-de-dado">
        <strong>Conta vinculada:</strong>
        <span>{{ construtora.Conta }}</span>
      </span>
    </div>
    <div class="linha-de-dados">
      <span class="item-de-dado">
        <strong>Cidade:</strong>
        <span>{{ cidade.Nome + " - " + cidade.EstadoNome }}</span>
      </span>
      <span class="item-de-dado">
        <strong>Tipo de empreendimento:</strong>
        <span>{{ empreendimento.TipoDeEmpreendimento }}</span>
      </span>
    </div>
    <div class="linha-de-dados">
      <span class="item-de-dado item-de-dado_largo">
        <strong>Nome do empreendimento:</strong>
        <span>{{ empreendimento.Nome }}</span>
      </span>
    </div>
    <div class="linha-de-dados">
      <span class="item-de-dado item-de-dado_largo">
        <strong>Endereço:</strong>
        <span>{{ imovel.EnderecoCompleto }}</span>
      </span>
    </div>
    <div class="linha-de-dados">
      <span class="item-de-dado">
        <strong>Valor da compra e venda:</strong>
        <span>{{ valorDaCompraEVenda }}</span>
      </span>
      <span class="item-de-dado">
        <strong>Participação do proponente:</strong>
        <span>{{ participacaoDoSolicitante }}</span>
      </span>
    </div>
    <div class="linha-de-dados">
      <span class="item-de-dado">
        <strong>Financiamento concedido:</strong>
        <span>{{ valorDoFinanciamentoAprovado }}</span>
      </span>
      <span class="item-de-dado">
        <strong>Aporte/subsídio da AGEHAB:</strong>
        <span>{{ subsidioDaAgehab }}</span>
      </span>
    </div>
    <div class="linha-de-dados">
      <span class="item-de-dado">
        <strong>Subsídio do Governo Federal:</strong>
        <span>{{ subsidioDoGovernoFederal }}</span>
      </span>
      <span v-if="!solicitacaoEhDoBonusMoradia" class="item-de-dado">
        <strong>FGTS do proponente a utilizar:</strong>
        <span>{{ fgtsDoSolicitante }}</span>
      </span>
      <span v-if="solicitacaoEhDoBonusMoradia" class="item-de-dado">
        <strong>Desconto da construtora:</strong>
        <span>{{ descontoDaConstrutora }}</span>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "dados-do-imovel",
  props: {
    construtora: { type: Object, default: () => ({}) },
    cidade: { type: Object, default: () => ({}) },
    empreendimento: { type: Object, default: () => ({}) },
    imovel: { type: Object, default: () => ({}) },
    valorDaCompraEVenda: { type: String, default: null },
    participacaoDoSolicitante: { type: String, default: null },
    valorDoFinanciamentoAprovado: { type: String, default: null },
    subsidioDaAgehab: { type: String, default: null },
    subsidioDoGovernoFederal: { type: String, default: null },
    fgtsDoSolicitante: { type: String, default: null },
    descontoDaConstrutora: { type: String, default: null },
    solicitacaoEhDoBonusMoradia: { type: Boolean, default: false },
  },
};
</script>



// WEBPACK FOOTER //
// DadosDoImovel.vue?3020351a